import { defineNuxtPlugin } from '#imports';
import { COPY_ADDITIONAL_TEXT } from '@/shared/constant';

export default defineNuxtPlugin({
	hooks: {
		'app:created': () => {
			document?.addEventListener('copy', (event) => {
				event.clipboardData?.setData('text/plain', document.getSelection()?.toString() + COPY_ADDITIONAL_TEXT['ru'] + window?.location?.hostname);
				event.preventDefault();
			});
		},
	},
});
